// @ts-ignore
import {useCallback, useEffect, useState} from "react";
import { isArray, isEqual, debounce } from "lodash";

type onBlurType = (value: any) => void;

/**
 * Управляет state, внедряет crud, отправляет данные на бэк. Отвечает за жизненный цикл данных внутри компонентов
 * @param propsValue
 * @param onBlur
 */
export const usePropsValueToState = (propsValue: any, onBlur: onBlurType) => {
    const [value, setValue] = useState(propsValue);
    const blurDebounced: onBlurType = useCallback(debounce(onBlur, 500), []);

    // update стейта, проверяем по обновленным пропсам
    useEffect(() => {
        if(!isEqual(value, propsValue)) {
            setValue([
                ...propsValue
            ])
        }
    }, [propsValue])

    useEffect(() => {
        if(!isEqual(value, propsValue)) {
            blurDebounced(value);
        }
    }, [value]);

    /**
     * Обновляет нужное значение по индексу
     * @param newItem
     * @param index
     */
    const updateValue = (newItem: any, index: number): void => {
        if(isArray(value)) {
            setValue([
                ...value.map((item, mapIndex) => (mapIndex === index ? newItem : item))
            ])
        }
    };

    /**
     * Удаляет по индексу
     * @param index
     */
    const deleteValue = (index: number): void => {
        if(isArray(value)) {
            setValue([
                ...value.filter((item, filterIndex) => filterIndex !== index)
            ]);
        }
    }

    return [
        value,
        setValue,
        updateValue,
        deleteValue
    ];
};
